import RiskLevelCharts from "../../../../components/risk-level-charts.jsx";

export default function CnpjRiskLevel({data}) {
    const cards = data?.cards;

    return (
        <RiskLevelCharts
            total={cards?.cnpjRegistrations}
            activeTotal={cards?.activeCnpjRegistrations}
            appsActive={cards?.companyAppsActive}
            riskLevels={data?.cnpjRiskLevels}
        />
    );
}
